<template>
  <div class="add-pro-wrapper">
    <!-- 标题与保存按钮 -->
    <el-row>
      <el-col :span="12"><Title title="添加音效"></Title></el-col>
      <el-col :span="12">
        <div style="width:100%;height:60px;padding-right:15px;box-sizing:border-box" class="flex_rec">
          <el-button type="primary" @click="save" :loading="isSaving">{{isLinkType?'保存':'保存并上传'}}</el-button>
        </div>
      </el-col>
    </el-row>

    <div class="add-pro-content">
      <el-row :gutter="15">
      <!-- 左模块 -->
        <el-col :span="18">
          <!-- 基本信息 -->
          <el-card class="box-card">
            <el-row :gutter="20">
              <!-- 左边 -->
              <el-col :span="4">
                <div class="part-info">
                  <div class="title">基本</div>
                  <div class="info">音效信息</div>
                </div>
              </el-col>
              <!-- 右边 -->
              <el-col :span="20">

                <!-- 名称 -->
                <el-row :gutter="20" class="mt10">
                  <el-col :span="24">
                      <el-input placeholder="请输入内容" v-model="form.name">
                        <template slot="prepend">名称</template>
                      </el-input>
                  </el-col>
                </el-row>

                <!-- 完整地址 -->
                <!-- 选项：自定义地址 / 网易云外链 -->
                <el-row :gutter="20" class="mt10" v-if="isLinkType">
                  <el-col :span="24">
                    <el-radio-group v-model="form.link_type" @change="onLinkTypeChange">
                      <el-radio label="custom">自定义地址</el-radio>
                      <el-radio label="netease">网易云外链</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>

                <!-- 输入区：根据选项切换 -->
                <el-row :gutter="20" class="mt10" v-if="isLinkType">
                  <!-- 自定义：整条 URL 由用户输入 -->
                  <el-col :span="24" v-if="form.link_type === 'custom'">
                    <el-input
                      v-model.trim="form.full_path"
                      clearable
                      placeholder="请输入完整外链地址，如 https://example.com/a.mp3">
                      <template slot="prepend">外链地址</template>
                    </el-input>
                  </el-col>

                  <!-- 网易云：只填 ID，前缀固定 -->
                  <el-col :span="24" v-else>
                    <el-input
                      v-model.trim="form.netease_id"
                      clearable
                      placeholder="请输入网易云歌曲ID，如 1854998259"
                      @input="onlyDigits('netease_id')"
                      @paste.native="parseNeteasePaste">
                      <template slot="prepend">{{ NETEASE_PREFIX }}</template>
                    </el-input>
                    <!-- 可选：给用户一个最终链接的预览 -->
                    <div class="mt5" style="font-size:12px;color:#909399;">
                      最终链接：<code style="word-break:break-all;">{{ computedFullPath }}</code>
                    </div>
                  </el-col>
                </el-row>

                <!-- 内容描述 -->
                <el-input
                  type="textarea"
                  style="margin-top:10px"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  placeholder="请输入内容"
                  v-model="form.discription">
                </el-input>
                <!-- 旧版扩展关键词 -->
                <span class="p-extra mb5">
                  旧版扩展关键词（兼容旧客户端，多个词用逗号隔开）。新的搜索词请在下方“标签与搜索词”中维护。
                </span>
              </el-col>
            </el-row>
          </el-card>

          <!-- 文件上传 -->
          <el-card class="box-card" v-if="!isLinkType">
            <el-row :gutter="20">
              <!-- 左边 -->
              <el-col :span="3">
                <div class="part-info">
                  <div class="title">文件</div>
                  <div class="info">文件上传</div>
                </div>
              </el-col>
              <!-- 右边 -->
              <el-col :span="21">
                <el-upload
                  class="upload-demo"
                  drag
                  action=""
                  ref="uploadHandler"
                  :auto-upload="false"
                  name="soundFile"
                  :multiple="false"
                  list-type="text"
                  :file-list="selectedFileList"
                  :on-change="selectFileChange"
                  :on-remove="fileRemove"
                  :on-exceed="fileExceed"
                  :on-preview="handlePreview"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传flac,m4a,mp3,wav,ogg,aac文件，且不超过10m</div>
                </el-upload>
                <!-- 上传进度面板（新增） -->
                <div v-if="upload.state !== 'idle'" class="upload-progress">
                  <div class="up-head">
                    <span class="up-name">{{ upload.fileName }}</span>
                    <span class="up-meta">{{ prettyBytes(upload.loaded) }} / {{ prettyBytes(upload.total) }}</span>
                  </div>

                  <el-progress :percentage="upload.percent" :status="upload.status"></el-progress>

                  <div class="up-row">
                    <span>速度：{{ prettyBytes(upload.speed) }}/s</span>
                    <span>剩余：{{ etaText }}</span>
                  </div>

                  <div class="up-ops">
                    <el-button v-if="upload.state==='uploading'" size="mini" @click="cancelUpload">取消</el-button>
                    <!-- <el-button v-else size="mini" @click="fileRemove">重新上传</el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <Player :currSrc="currSrc" ref="player"></Player>
          </el-card>
          <el-card class="box-card sound-metadata-card">
            <div slot="header" class="clearfix">
              <strong>资源信息与正文</strong>
              <span class="metadata-card-tip">歌曲可补充歌手、专辑、封面和完整歌词</span>
            </div>
            <SoundResourceContentEditor ref="resourceEditor"></SoundResourceContentEditor>
          </el-card>
          <el-card class="box-card sound-metadata-card">
            <div slot="header" class="clearfix">
              <strong>标签与搜索词</strong>
              <span class="metadata-card-tip">将在音效创建成功后自动关联</span>
            </div>
            <SoundTagSearchEditor ref="tagEditor"></SoundTagSearchEditor>
          </el-card>
          <el-card class="box-card sound-metadata-card">
            <div slot="header" class="clearfix">
              <strong>版权与展示控制</strong>
              <span class="metadata-card-tip">不确定时保持“未审核、沿用当前展示”即可</span>
            </div>
            <SoundRightsAssignmentEditor ref="rightsEditor"></SoundRightsAssignmentEditor>
          </el-card>
        </el-col>

        <!-- 右模块 -->
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>状态</span>
            </div>
            <p class="p-extra mb5">启用状态(用户是否可见)</p>
            <el-select v-model="form.status" placeholder="请选择账号状态" style="width:100%" class="mb10">
              <el-option
                v-for="item in status_arr"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <p class="p-extra mb5">推荐状态(是否显示在最近上传)</p>
            <el-select v-model="form.recommend" placeholder="请选择推荐状态" style="width:100%" class="mb10">
              <el-option
                v-for="item in status_arr"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <p class="p-extra mb5">分类(归属的基础分类)</p>
            <el-select v-model="form.category_id" placeholder="请选择分类" style="width:100%">
              <el-option
                v-for="item in category_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

            <el-input placeholder="请输入内容" v-model="form.wnb" style="width:100%;margin-top:10px">
              <template slot="prepend">下载所需币</template>
            </el-input>
          </el-card>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import Title from "./components/Title"
import apis from "@/api/index"
import Player from "@/components/Player.vue"
import SoundResourceContentEditor from "@/components/sounds/SoundResourceContentEditor.vue"
import SoundTagSearchEditor from "@/components/sounds/SoundTagSearchEditor.vue"
import SoundRightsAssignmentEditor from "@/components/sounds/SoundRightsAssignmentEditor.vue"
import axios from 'axios'
export default {
  name:'addProducts',
    components:{
      Title,
      Player,
      SoundResourceContentEditor,
      SoundTagSearchEditor,
      SoundRightsAssignmentEditor
    },
    data(){
      return{
        NETEASE_PREFIX: 'http://music.163.com/song/media/outer/url?id=',
        form:{
          link_type: 'custom',   // 'custom' | 'netease'
          wnb:0,
          status:1,
          recommend:1,
          full_path: '',         // 提交给后端的一致字段
          netease_id: ''         // 仅当 link_type = 'netease' 时使用
        },
        status_arr:[
          {name:'启用/激活/推荐',value:1},
          {name:'禁用/未激活/不推荐',value:0},
          {name:'未设置',value:null},
        ],   
        devices_list:[],
        category_list:[],
        currSrc:"",
        // 新增：上传状态
        upload:{
          state: 'idle',     // idle | uploading | success | error
          status: undefined, // el-progress 的状态
          fileName: '',
          percent: 0,
          loaded: 0,
          total: 0,
          speed: 0,
          lastTs: 0,
          lastLoaded: 0,
          cancelSource: null
        },
        addSourceType:this.$route.params.addSourceType || "localFile", // 新增：来源类型（localFile：本地上传，linkUrl：外链）
        isSaving:false, // 新增：保存按钮状态
        selectedFileList: [], // 新增：选中的文件列表
      }
    },
    methods:{
      async save(){
        this.isSaving = true

        // 1) 必填校验（避免无意义的上传）
        if (!this.form.name) {
          this.$message.error('请输入名称');
          this.isSaving = false;
          return;
        }
        if (!this.form.category_id) {
          this.$message.error('请先选择分类');
          this.isSaving = false;
          return;
        }

        // 把现有 this.form 转成 FormData（保留你原来的做法）
        const formArr = Object.entries(this.form)
        let formData = new FormData();
        formArr.forEach(([k,v])=>{
          if(v !== null && v !== undefined){
            formData.append(k, v)
          }
        })

        // 分支1：外链（无文件）——保持你原有接口调用（无进度）
        if (this.isLinkType && !this.form.sound) {
          try{
            const res = await apis.sounds.create(formData)
            if(res.data.code == 1){
              await this.completeCreate(res, '创建成功')
            }else{
              this.$message({message:res.data.msg,type:'error'})
            }
          }catch(e){
            this.$message({message:String(e), type:'error'})
          }
          this.isSaving = false;
          return
        }

        // 分支2：本地文件上传 —— 使用 axios + onUploadProgress
        // 后端是 ThinkPHP 的 Sounds@create（你原本 apis.sounds.create 的地址）

        if (!this.form.sound) {
          this.$message.error('请选择要上传的文件');
          this.isSaving = false;
          return;
        }


        // 初始化进度
        this.upload = {
          state: 'uploading',
          status: undefined,
          fileName: this.form.sound?.name || '',
          percent: 0,
          loaded: 0,
          total: this.form.sound?.size || 0,
          speed: 0,
          lastTs: performance.now(),
          lastLoaded: 0,
          cancelSource: axios.CancelToken.source()
        }

        try{
          console.log('formData',formData)
          let upResult = await apis.sounds.create(formData, {
            cancelToken: this.upload.cancelSource.token,
            onUploadProgress: (e) => {
              if(!e.total) return
              const now = performance.now()
              this.upload.total = e.total
              this.upload.loaded = e.loaded
              this.upload.percent = Math.round(e.loaded * 100 / e.total)

              // 500ms 更新一次速度
              const dt = (now - this.upload.lastTs) / 1000
              if (dt >= 0.5) {
                const dBytes = e.loaded - this.upload.lastLoaded
                this.upload.speed = dBytes / dt
                this.upload.lastTs = now
                this.upload.lastLoaded = e.loaded
              }
            }
          })

          console.log('upResult',upResult)
          if(upResult.data.code == 1){
            this.upload.state = 'success'
            this.upload.status = 'success'
            await this.completeCreate(upResult, '上传并创建成功')
          }else{
            this.upload.state = 'success'
            this.upload.status = 'warning'
            // this.$message({message:upResult.data.msg,type:'error',duration:0,showClose: true})
            let errorMsg = upResult.data.msg || '上传失败'
            this.clearSelectedFiles(errorMsg)
            this.isSaving = false;
            
          }
          
          
        }catch(err){
          if (axios.isCancel(err)) {
            this.$message({message:"已取消上传", type:"info"})
            this.upload.state = 'idle'
            this.isSaving = false;
          } else {
            this.upload.state = 'error'
            this.upload.status = 'exception'
            this.$message({message:`上传失败：${err?.message || '网络异常'}`, type:'error',duration:0,showClose: true})
          }

        }
      },
      async completeCreate(response, successMessage) {
        const soundId = Number(response?.data?.data?.id || 0)
        if (!soundId) {
          this.$message({
            message: '音效已经创建，但服务端没有返回音效 ID，标签和搜索词暂未关联。',
            type: 'warning',
            duration: 0,
            showClose: true
          })
          this.$router.push({name:'soundsList'})
          return
        }

        try {
          // 标签与版权是两个独立扩展模块；音效创建成功后再用 sound_id 分别关联。
          // 版权编辑器在用户未填写任何内容时会跳过写库，继续沿用历史展示逻辑。
          await Promise.all([
            this.$refs.resourceEditor.persistDraft(soundId),
            this.$refs.tagEditor.persistDraft(soundId),
            this.$refs.rightsEditor.persistDraft(soundId)
          ])
          this.$message({
            message: successMessage,
            type: 'success',
            duration: 0,
            showClose: true
          })
          this.$router.push({name:'soundsList'})
        } catch (error) {
          this.$message({
            message: `音效已经创建，但资源信息、标签、搜索词或版权信息保存失败：${error?.message || error}`,
            type: 'warning',
            duration: 0,
            showClose: true
          })
          this.$router.push({name:'updateSound', query:{id:soundId}})
        }
      },
      cancelUpload(){
        if (this.upload.cancelSource) {
          this.upload.cancelSource.cancel('user cancel')
        }
      },

      prettyBytes(n){
        if (n === 0) return '0 B'
        if (!n && n !== 0) return '--'
        const u = ['B','KB','MB','GB']; let i=0; let x=n
        while (x>=1024 && i<u.length-1) { x/=1024; i++ }
        return x.toFixed(x>=100||i===0?0:1)+' '+u[i]
      },
      getCategoryList(){
        apis.category.read(0).then(res=>{
          console.log('res',res)
          this.category_list = res.data.data
        }).catch(err=>{
          console.log('err',err)
        })
      },

      handlePreview(file) {
        let f = file.raw;
        this.$refs.player.play({
          src:window.URL.createObjectURL(f),
          name:f.name
        })
      },
      selectFileChange(file){
        this.$set(this.form,'sound',file.raw)
        this.$set(this.form,'name',file.name.split('.')[0])
        //永远只展示最后选择的一个资源
        this.selectedFileList = [file]

        this.upload.state = 'idle'
        this.upload.status = undefined
      },
      fileExceed(){
        this.$message({type:"info",message:"一次只能上传一个"})
      },
      
      fileRemove(){
        console.log("fileRemove")
        this.$set(this.form,'sound',null)
      },
      clearSelectedFiles(errorMsg){ 
        this.selectedFileList = []
        this.$refs.uploadHandler.clearFiles()
        this.$set(this.form,'sound',null)
        this.$alert(errorMsg + "\t" + "已清空选择的文件，请重新选择要上传的文件。", "提示",{
          confirmButtonText: '确定',
          callback: action => {
            if (action === 'confirm') {
                this.upload.state = 'idle'
                this.upload.status = undefined
            }
          }
        })
      },
      onLinkTypeChange(val) {
        if (val === 'netease') {
          // 如果用户之前在 full_path 粘贴过整条网易云链接，则尝试自动提取 id
          const m = (this.form.full_path || '').match(/id=(\d+)/)
          if (m) this.form.netease_id = m[1]
          if (!this.form.netease_id) this.form.full_path = this.NETEASE_PREFIX
        }
      },
      // 只允许数字，避免把非数字字符带进 ID
      onlyDigits(field) {
        this.form[field] = (this.form[field] || '').replace(/\D/g, '')
      },
      // 粘贴整条链接时自动截出 id
      parseNeteasePaste(e) {
        const text = (e.clipboardData || window.clipboardData).getData('text') || ''
        const m = text.match(/id=(\d+)/)
        if (m) {
          e.preventDefault()
          this.form.netease_id = m[1]
        }
      }
    },
    mounted(){
        this.getCategoryList()
        console.log('mounted',this.$route)
    },
    created(){
      console.log('created',this.$route)
    },
    computed:{
      isLinkType(){
        return !!(this.addSourceType && this.addSourceType === 'linkUrl')
      },
      etaText(){
        if (!this.upload.speed || !this.upload.total) return '--'
        const remain = Math.max(0, this.upload.total - this.upload.loaded)
        const sec = Math.max(1, Math.round(remain / this.upload.speed))
        const m = Math.floor(sec / 60), s = sec % 60
        return m ? `${m}分${s}秒` : `${s}秒`
      },
      // 统一产出最终地址；同时用于预览
      computedFullPath() {
        return this.form.link_type === 'netease'
          ? this.NETEASE_PREFIX + (this.form.netease_id || '')
          : (this.form.full_path || '')
      }
    },
    watch:{
      // 保持 form.full_path 与选择结果同步，后端永远拿 full_path
      computedFullPath(newVal) {
        this.form.full_path = newVal
      }
    }
}
</script>

<style lang="scss">
.add-pro-wrapper{
  .add-pro-content{
    box-sizing: border-box;
    width: 100%;
    padding:15px;
  }
  .box-card{
    margin-bottom:5px;
  }
  .part-info{
    // @include flex_ccc();
    // background: brown;
    .title{
      font-size: 18px;
      color:#333;
    }
    .info{
      font-size: 12px;
      color:#999;
    }
  }
}
.sound-metadata-card {
  .metadata-card-tip {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
    font-weight: 400;
  }
}
/* 新增：上传进度小面板 */
.upload-progress {
  margin-top: 10px;
  border: 1px dashed var(--el-border-color, #dcdfe6);
  border-radius: 8px;
  padding: 10px 12px;
  .up-head, .up-row {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
  }
  .up-name { 
    font-weight: 600; 
    max-width: 70%; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap; 
    color: #606266; 
  }
  .up-ops { margin-top: 6px; }
}
</style>
